import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
// import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

import { createSelector } from "reselect";
import { callbackUser } from "./service/loginService";
import { clearExistingToken } from "../../Utils/CommonUtils";
import { getVersion } from "../../Utils/CommonService";
import dateFormat from "dateformat";
import "./auth.scss";

const ResetPassword = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));
  // Inside your component
  const InvalidCredential = useSelector((state) => state.common.user.error);
  const { user, error, loading, errorMsg } = useSelector(loginpageData);
  const version = useSelector((state) => state.common.version);
  const versionDate = useSelector((state) => state.common.versionDate);

  const [userLogin, setUserLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);

  const formattedVersionDate = versionDate
    ? dateFormat(new Date(versionDate), "dd-mm-yyyy HH:MM:ss")
    : "N/A";

  //   useEffect(() => {
  //     if (user && user) {
  //       const updatedUserData =
  //         process.env.REACT_APP_DEFAULTAUTH === "firebase"
  //           ? user.multiFactor.user.email
  //           : user.user.email;
  //       const updatedUserPassword =
  //         process.env.REACT_APP_DEFAULTAUTH === "firebase"
  //           ? ""
  //           : user.user.confirm_password;
  //       setUserLogin({
  //         email: updatedUserData,
  //         password: updatedUserPassword,
  //       });
  //     }
  //   }, [user]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: userLogin.email || "",
      password: userLogin.password || "",
      confirmPassword: "", // New field for re-enter password
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
      confirmPassword: Yup.string()
        .required("Please Re-enter Your Password")
        .oneOf([Yup.ref("password"), null], "Passwords must match"), // Ensure passwords match
    }),
    onSubmit: (values) => {
      callbackUser(
        validation.values.email,
        validation.values.password,
        0,
        props.router.navigate
      );
      // navigate("/hub/information");
      //   dispatch(loginUser(values, props.router.navigate));
    },
  });

  const signIn = (type) => {
    clearExistingToken();
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //for facebook and google authentication
  const socialResponse = (type) => {
    signIn(type);
  };

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  useEffect(() => {
    getVersion();
  }, [version, versionDate]);

  // document.title = "Basic SignIn | Velzon - React Admin & Dashboard Template";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50"></div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4 login-container">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Create Password</h5>
                      <p className="text-muted">
                        Please enter your new password
                      </p>
                    </div>
                    {InvalidCredential && InvalidCredential ? (
                      <Alert color="danger">{InvalidCredential}</Alert>
                    ) : null}
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                      >
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            New Password
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control pe-5"
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="confirm-password-input"
                          >
                            Confirm Password
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="confirmPassword"
                              value={validation.values.confirmPassword || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control pe-5"
                              placeholder="Confirm Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.confirmPassword &&
                                validation.errors.confirmPassword
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.confirmPassword &&
                            validation.errors.confirmPassword ? (
                              <FormFeedback type="invalid">
                                {validation.errors.confirmPassword}
                              </FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              {/* <i className="ri-eye-fill align-middle"></i> */}
                              a
                            </button>
                          </div>
                        </div>

                        <div className="mt-4">
                          <Button
                            disabled={error ? null : loading ? true : false}
                            color="success"
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            {loading ? (
                              <Spinner size="sm" className="me-2">
                                {" "}
                                Loading...{" "}
                              </Spinner>
                            ) : null}
                            Confirm
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <Container fluid>
          <Row className="justify-content-center align-items-center">
            <Col sm="auto">
              <div className="text-sm-end d-none d-sm-block">
                {`Version: ${version}`}
              </div>
            </Col>
            <Col sm="auto">
              <div className="text-sm-center d-none d-sm-block">|</div>
            </Col>
            <Col sm="auto">
              <div className="text-sm-end d-none d-sm-block">
                {`Version Date: ${formattedVersionDate}`}
              </div>
            </Col>
          </Row>
        </Container>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default ResetPassword;
